import loadable from '@loadable/component';
import expertCategoryQuery from './query.graphql';

const ExpertCategory = loadable(() =>
  import(/* webpackChunkName: "expert" */ './expert-category')
);

ExpertCategory.graphQL = expertCategoryQuery;

ExpertCategory.variables = ({ slug }) => ({
  slug,
});

export default ExpertCategory;
